<template>
  <v-container fluid>
    <v-layout row wrap>
      <v-flex class="d-flex justify-space-between mb-3 align-center" xs12>
        <h3 class="font-weight-bold">Office Revenue Head Report</h3>
        <div class="text-xs-right">
          <export-summary-report-button model="office-revenue-head" :export-date="range"
                                        v-if="$oauth.checkIfHasPermission(['export office-revenue-head-summary-report'])"/>
          <refresh-button :click-function="updateByOffice"></refresh-button>
        </div>
      </v-flex>
      <v-flex xs12>

        <v-card>
          <v-layout class="py-1 mx-2" row wrap>
            <v-flex xs6 class="d-flex align-center">
              <custom-date-range-picker @change="updateByOffice"
                                        v-model="range"/>
            </v-flex>
            <v-flex xs6 class="d-flex align-center">
              <v-autocomplete
                  :items="OfficeTypeConstant"
                  @change="updateByOffice"
                  clearable
                  flat
                  item-text="text"
                  item-value="value"
                  label="Filter by Ofice Type"
                  outlined
                  solo
                  v-model="office_type"
              />
            </v-flex>
          </v-layout>

          <v-divider/>
          <v-card-text class="pa-0">
            <v-simple-table
                class="elevation-0 pb-6"
                v-if="$oauth.checkIfHasPermission(['read office-revenue-head-summary-report'])"
            >
              <thead>
              <!--              <v-progress-linear-->
              <!--                  :active="progressLinearLoading"-->
              <!--                  :indeterminate="progressLinearLoading"-->
              <!--                  absolute-->
              <!--                  bottom-->
              <!--                  color="primary"-->
              <!--              ></v-progress-linear>-->
              <v-overlay :value="progressLinearLoading">
                <v-progress-circular
                    indeterminate
                    size="64"
                ></v-progress-circular>
              </v-overlay>
              <tr>
                <th class="text-center">S.N</th>
                <th>Office</th>
                <!--                <th class="text-center">Cost(USD)</th>-->
                <th class="text-center">Visa Fee(USD)</th>
                <th class="text-center">Late Fee(USD)</th>
                <th class="text-center">Penalty Fee(USD)</th>
                <th class="text-center">Border Penalty Fee(USD)</th>
                <th class="text-center">Transfer Fee(USD)</th>
                <th class="text-center">Overstay Fee(USD)</th>
                <th class="text-center">Total Fee(USD)</th>
                <th class="text-center">Total Fee(NPR)</th>
                <th class="text-center">Exempt Fee(USD)</th>
              </tr>
              </thead>
              <tbody v-if="office_wise_data !== []">
              <tr v-for="(item,i) in office_wise_data">
                <td class="text-center">{{ i + 1 }}</td>
                <td>{{ item.office }}</td>
                <!--                <td class="text-center">{{ parseFloat(item.cost) }}</td>-->
                <td class="text-center">{{ parseFloat(item.visa_fee).toFixed(2) }}</td>
                <td class="text-center">{{
                    (/^[-+]?[0-9]*\.?[0-9]+([eE][-+]?[0-9]+)$/).test(item.late_fee) ? '0.00' : parseFloat(item.late_fee).toFixed(2)
                  }}
                </td>
                <td class="text-center">{{ parseFloat(item.penalty_fee.toFixed(2)) }}</td>
                <td class="text-center">{{ parseFloat(item.border_penalty_fee).toFixed(2) }}</td>
                <td class="text-center">{{ parseFloat(item.transfer_cost).toFixed(2) }}</td>
                <td class="text-center">{{
                    (/^[-+]?[0-9]*\.?[0-9]+([eE][-+]?[0-9]+)$/).test(item.overstay_cost) ? '0.00' : parseFloat(item.overstay_cost).toFixed(2)
                  }}
                </td>
                <td class="text-center">{{ parseFloat(item.total_fee).toFixed(2) }}</td>
                <td class="text-center">{{ parseFloat(item.cost_npr).toFixed(2) }}</td>
                <td class="text-center text-red">{{
                    (/^[-+]?[0-9]*\.?[0-9]+([eE][-+]?[0-9]+)$/).test(item.exempt_cost) ? '0.00' : '-' + parseFloat(item.exempt_cost).toFixed(2)
                  }}
                </td>
              </tr>
              <tr class="font-weight-bold" v-if="office_wise_data !== []">
                <td class="text-center" colspan="2">Total</td>
                <td class="text-center">{{ total_visa_fee.toFixed(2) }}</td>
                <td class="text-center">{{
                    (/^[-+]?[0-9]*\.?[0-9]+([eE][-+]?[0-9]+)$/).test(total_late_fee) ? '0.00' : total_late_fee.toFixed(2)
                  }}
                </td>
                <td class="text-center">{{ total_penalty_fee.toFixed(2) }}</td>
                <td class="text-center">{{ total_border_penalty_fee.toFixed(2) }}</td>
                <td class="text-center">{{ total_transfer_cost.toFixed(2) }}</td>
                <td class="text-center">{{
                    (/^[-+]?[0-9]*\.?[0-9]+([eE][-+]?[0-9]+)$/).test(total_overstay_cost) ? '0.00' : total_overstay_cost.toFixed(2)
                  }}
                </td>
                <td class="text-center">{{ total_total_fee.toFixed(2) }}</td>
                <td class="text-center">{{ total_cost_npr.toFixed(2) }}</td>
                <td class="text-center text-red">{{
                    (/^[-+]?[0-9]*\.?[0-9]+([eE][-+]?[0-9]+)$/).test(total_exempt_cost) ? '0.00' : '-' + total_exempt_cost.toFixed(2)
                  }}
                </td>
              </tr>
              </tbody>
              <tbody v-else>
              <tr class="text-center">
                <td>No record found</td>
              </tr>
              </tbody>
            </v-simple-table>
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import {mapActions, mapGetters} from 'vuex';
import CustomDateRangePicker from "../../components/CustomDateRangePicker";
import {commonStoreMixin} from "../../mixins/commonStoreMixin";
import IssuedVisaFooter from "../../components/footer/IssuedVisaFooter";
import ExportSummaryReportButton from "../../components/ExportSummaryReportButton";
import Http from "axios";
import {VERSIONED_API_URL} from "../../config/config";

const REVENUE_SUMMARY_REPORT_URL = `${VERSIONED_API_URL}/summary-report/office-revenue-head`;
import {OfficeTypeConstant} from '../../constants/AppConstant'
import RefreshButton from "@/components/RefreshButton";

export default {
  name: "OfficeRevenueHeadReport",
  data() {
    return {
      office_wise_data: [],
      range: {},
      OfficeTypeConstant,
      office_type: null,
      serial_no: 0,
      total_visa_fee: 0,
      total_late_fee: 0,
      total_penalty_fee: 0,
      total_border_penalty_fee: 0,
      total_transfer_cost: 0,
      total_overstay_cost: 0,
      total_total_fee: 0,
      total_cost_npr: 0,
      total_exempt_cost: 0,
    };
  },
  components: {RefreshButton, CustomDateRangePicker, IssuedVisaFooter, ExportSummaryReportButton},
  mixins: [commonStoreMixin],
  computed: {
    ...mapGetters({
      loading: "ArrivalDepartureReport/reportLoading",
    }),
    from_main_office() {
      return this.$store.state.AuthUser.user.from_main_office;
    },
    offices() {
      return this.$store.state.OfficeList.offices;
    }
  },
  methods: {
    updateByOffice() {
      let params = {};
      this.progressLinearLoading = true;
      if (Object.keys(this.range).length > 0)
        params.date_range = this.range;

      if (this.office_type != null) {
        params.office_type = this.office_type;
      }

      Http.get(REVENUE_SUMMARY_REPORT_URL, {
        params: params
      })
          .then((res) => {
            this.office_wise_data = res.data.data;
            this.total_total_fee = 0;
            this.total_late_fee = 0;
            this.total_penalty_fee = 0;
            this.total_border_penalty_fee = 0;
            this.total_transfer_cost = 0;
            this.total_overstay_cost = 0;
            this.total_visa_fee = 0;
            this.total_exempt_cost = 0;
            this.total_cost_npr = 0;
            this.office_wise_data.forEach(item => {
              this.total_visa_fee += item.visa_fee
              this.total_late_fee += (/^[-+]?[0-9]*\.?[0-9]+([eE][-+]?[0-9]+)$/).test(item.late_fee) ? 0.00 : item.late_fee
              this.total_penalty_fee += item.penalty_fee
              this.total_border_penalty_fee += item.border_penalty_fee
              this.total_transfer_cost += item.transfer_cost
              this.total_overstay_cost += (/^[-+]?[0-9]*\.?[0-9]+([eE][-+]?[0-9]+)$/).test(item.overstay_cost) ? 0.00 : item.overstay_cost
              this.total_total_fee += item.total_fee
              this.total_cost_npr += item.cost_npr
              this.total_exempt_cost += (/^[-+]?[0-9]*\.?[0-9]+([eE][-+]?[0-9]+)$/).test(item.exempt_cost) ? 0.00 : item.exempt_cost
            });
            this.progressLinearLoading = false;
          })
          .catch(() => {
            this.$store.commit('Notification/showError', 'Something went wrong');
            this.progressLinearLoading = false;
          });
    }


  },
  mounted() {
    this.progressLinearLoading = true;
    Http.get(REVENUE_SUMMARY_REPORT_URL)
        .then((res) => {
          this.office_wise_data = res.data.data;
          this.total_total_fee = 0;
          this.total_late_fee = 0;
          this.total_penalty_fee = 0;
          this.total_border_penalty_fee = 0;
          this.total_transfer_cost = 0;
          this.total_overstay_cost = 0;
          this.total_visa_fee = 0;
          this.total_exempt_cost = 0;
          this.total_cost_npr = 0;
          this.office_wise_data.forEach(item => {
            this.total_visa_fee += item.visa_fee
            this.total_late_fee += (/^[-+]?[0-9]*\.?[0-9]+([eE][-+]?[0-9]+)$/).test(item.late_fee) ? 0.00 : item.late_fee
            this.total_penalty_fee += item.penalty_fee
            this.total_border_penalty_fee += item.border_penalty_fee
            this.total_transfer_cost += item.transfer_cost
            this.total_overstay_cost += (/^[-+]?[0-9]*\.?[0-9]+([eE][-+]?[0-9]+)$/).test(item.overstay_cost) ? 0.00 : item.overstay_cost
            this.total_total_fee += item.total_fee
            this.total_cost_npr += item.cost_npr
            this.total_exempt_cost += (/^[-+]?[0-9]*\.?[0-9]+([eE][-+]?[0-9]+)$/).test(item.exempt_cost) ? 0.00 : item.exempt_cost
          });
          this.progressLinearLoading = false;
        })
        .catch(() => {
          this.$store.commit('Notification/showError', 'Something went wrong');
          this.progressLinearLoading = false;
        });

    this.range = {
      start: new Date().toISOString().substr(0, 10),
      end: new Date().toISOString().substr(0, 10)
    }
  }
}
</script>
